var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_3361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9997 8.25C12.833 8.25 5.00467 13.9517 1.83301 22C5.00467 30.0483 12.833 35.75 21.9997 35.75C31.1755 35.75 38.9947 30.0483 42.1663 22C38.9947 13.9517 31.1755 8.25 21.9997 8.25ZM21.9997 31.1667C16.9397 31.1667 12.833 27.06 12.833 22C12.833 16.94 16.9397 12.8333 21.9997 12.8333C27.0597 12.8333 31.1663 16.94 31.1663 22C31.1663 27.06 27.0597 31.1667 21.9997 31.1667ZM21.9997 16.5C18.9655 16.5 16.4997 18.9658 16.4997 22C16.4997 25.0342 18.9655 27.5 21.9997 27.5C25.0338 27.5 27.4997 25.0342 27.4997 22C27.4997 18.9658 25.0338 16.5 21.9997 16.5Z",
    fill: "#D10A11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_3361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.61a1d338e0f50008867bd1d9e7f4f72f.svg";
export { ForwardRef as ReactComponent };